



























import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { setScheduleJson, SetScheduleJsonReq,getScheduleJson,GetScheduleJsonReq } from "@/api/device";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
@Component
export default class ScheduleJsonDialog extends Vue {
  @Prop({ default: null, required: true }) private meterID!: string;
  private dialogVisible: boolean = false;
  private content: string = "";
  private schedule: string = "";
  private clickShow() {
    this.dialogVisible = true;
    this.getSche()
  }

  private async sendData() {
    let req: SetScheduleJsonReq = <SetScheduleJsonReq>{};
    req.meterID = this.meterID;
    req.content = this.content;
    req.schedule = Number(this.schedule);
    setScheduleJson(req);
  }

  // private created(){
    
  // }

  private async getSche(){
    let req: GetScheduleJsonReq = <GetScheduleJsonReq>{meterID:this.meterID};
    let res = await getScheduleJson(req)
    if(!!res.data){
      this.content = res.data.content
      this.schedule = res.data.schedule.toString()
    }
  }
}
